import { makeStyles } from '@material-ui/core/styles';
import { COLORS, DIMENSIONS } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	main: {
		minHeight: `calc(100vh - ${DIMENSIONS.NAVBAR_HEIGHT_XS + DIMENSIONS.TABBAR_HEIGHT_XS + theme.spacing(5.5)}px)`,
		paddingTop: `${2 * DIMENSIONS.NAVBAR_HEIGHT + DIMENSIONS.TABBAR_HEIGHT + theme.spacing(2)}px`,
		paddingBottom: theme.spacing(3.5),
		paddingRight: theme.spacing(3),
		paddingLeft: theme.spacing(3),
		[theme.breakpoints.up('sm')]: {
			minHeight: `calc(100vh - ${DIMENSIONS.NAVBAR_HEIGHT + DIMENSIONS.TABBAR_HEIGHT + theme.spacing(7)}px)`,
			paddingTop: `${2 * DIMENSIONS.NAVBAR_HEIGHT + DIMENSIONS.TABBAR_HEIGHT + theme.spacing(3.5)}px`
		},
		backgroundColor: COLORS.BACKGROUND
	}
}));
